import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IUsersService } from "services/UsersService";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

type PropertyManagerSelectProps = {
  PropertyManagerSelectModels: GuidSelectModel[];
  Loading: boolean;
  LastUpdateTime: Date;
};

const initialState: PropertyManagerSelectProps = {
  PropertyManagerSelectModels: new Array<GuidSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const propertyManagerSelectSlice = createSlice({
  name: "propertyManagerSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPropertyManagerSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getPropertyManagerSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getPropertyManagerSelectModels.fulfilled, (state, action) => {
        state.PropertyManagerSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getPropertyManagerSelectModels = createAsyncThunk("PropertyManagers/GetSelectModels", async () => {
  const usersService = container.get<IUsersService>(SERVICE_TYPES.UsersService);
  return await usersService.getPropertyManagerSelectModels();
});

export const selectPropertyManagerSelectModels = (state: RootState) => {
  return state.propertyManagerSelect.PropertyManagerSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.propertyManagerSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.propertyManagerSelect.LastUpdateTime;
};

export default propertyManagerSelectSlice.reducer;
